export const lawsuitStatus = [
  {
    value: 1,
    label: "Criado",
  },
  {
    value: 2,
    label: "Aguardando documento",
  },
  {
    value: 3,
    label: "Aguardando validação",
  },
  {
    value: 4,
    label: "Concluído",
  },
];
